import { render } from "./FoodMenu.vue?vue&type=template&id=5863db9d&scoped=true"
import script from "./FoodMenu.vue?vue&type=script&lang=js"
export * from "./FoodMenu.vue?vue&type=script&lang=js"

import "./FoodMenu.vue?vue&type=style&index=0&id=5863db9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5863db9d"]])

export default __exports__